<template>
  <OnboardingLayout
    title="Credit Check"
    description="Please enter your BVN for an automated credit profile assessment."
    @onButtonClick="submitForm"
    imageDescription="Kindly input your BVN to enable us run a credit assessment."
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div
      v-if="checkFailed"
      class="error"
      style="
        color: red;
        font-weight: bold;
        padding: 10px;
        border: 1px solid red;
        background-color: #f8d7da;
        width: 80%;
      "
    >
      <p>
        Thank you for undergoing the credit appraisal process. Our team will
        reach out to you on next steps to complete this process
      </p>
      <!-- <p>
        You do not meet the credit criteria to use this service! Please reach
        out to our
        <a
          target="_blank"
          style="text-decoration: underline;"
          href="https://arnergy.com/contacts"
          >support team</a
        >
        for assistance.
      </p> -->
    </div>
    <div class="summary-container">
      <div class="summary">
        <el-form
          ref="form"
          :rules="{
            bvn: [
              {
                required: true,
                message: 'Please enter your BVN',
                trigger: 'blur',
              },
              { validator: validateBVNinput, trigger: 'blur' },
            ],
          }"
          :model="formData"
        >
          <el-form-item label="Bank Verification Number (BVN)" prop="bvn">
            <el-input
              placeholder="Insert your BVN here"
              v-model="formData.bvn"
              @change="checkCanContinue"
              @input="validateNumberInput"
            ></el-input>
          </el-form-item>
        </el-form>
        <div
          style="
            display: flex;
            color: grey;
            margin-left: -2px;
            align-content: baseline;
          "
        >
          <i
            class="fas fa-lg fa-info-circle"
            style="size: 20px; margin-right: 5px"
          ></i>
          <small
            >Your information is protected by Nigeria Data Protection
            Regulation (NDPR)</small
          >
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import OnboardingService from "@/services/onboarding.js";
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "BVNCheck",
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  components: {
    OnboardingLayout,
    "el-form": Form,
    "el-form-item": FormItem,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  data() {
    return {
      canContinue: false,
      showLoading: false,
      checkFailed: false,
      skipCreditCheck: false,
      nextPageName: "",
      // nextPageName: "KYCUpload",
      formData: {
        bvn: "",
      },
      isExistingUser: false,
    };
  },
  methods: {
    validateNumberInput(event) {
      // Remove any non-numeric characters
      this.formData.bvn = this.formData.bvn.replace(/\D/g, "");
    },
    checkCanContinue() {
      const { bvn } = this.formData;
      if (bvn && bvn.length > 9) {
        this.canContinue = true;
      } else {
        this.canContinue = false;
      }
    },
    validateBVNinput(rule, value, callback) {
      if (value.length !== 11) {
        callback(new Error("Your BVN must be 11 digits long"));
      } else {
        callback();
      }
    },
    async shouldSkipCreditCheck() {
      const res = await OnboardingService.shouldSkipCreditCheck();
      if (!res || !res.data) return;
      // this.navTo(this.nextPageName);
      this.skipCreditCheck = true;
    },
    async updateDBData() {
      if (this.isExistingUser) {
        this.nextPageName = "OnboardContractUpload";
      } else {
        this.nextPageName = "KYCUpload";
      }

      const data = {
        bvn: this.formData.bvn,
        customerid: localStorage.getItem("customerId"),
      };

      if (this.skipCreditCheck) {
        this.navTo(this.nextPageName);
        return;
      }
      const onboardingStateId = localStorage.getItem("onboardingStateId");
      const HTTP = this.$httpUtils.FASTHTTP;
      try {
        this.showLoading = true;
        let res = await HTTP.post(
          `/creditcheck/check-credit-rating?onboardingStateId=${onboardingStateId}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        );

        this.showLoading = false;
        if (res.data.isPerforming === true) {
          this.showSuccessMsg({ message: "Credit Check Passed!" });
          this.navTo(this.nextPageName);
          return;
        } else {
          this.checkFailed = true;
          this.showErrorMsg({ message: res.data.message });
        }
      } catch (error) {
        this.checkFailed = true;
        this.showLoading = false;
        console.log(error);
        this.showErrorMsg({
          message: "Unable to complete action, please try again",
        });
      }
    },
    async checkIfExistingUSer() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = `/onboardingstate/state`;
      try {
        const response = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });

        // set the customer id in the local storage
        localStorage.setItem("customerId", response.data.customerid);
        this.isExistingUser = response.data.isExistingUser;
      } catch (error) {
        console.log({ error });
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateDBData();
        } else {
          // Form validation failed
        }
      });
    },
  },
  async mounted() {
    await this.shouldSkipCreditCheck();
    await this.checkIfExistingUSer();
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.downPayment {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}
.tenureMonth {
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.buildingType {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.address {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
    // font-weight: normal;
  }
}

.quantity label {
  font-size: 16px;
  color: #727272;
  // font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  margin-left: 6px;
  border: 1px solid #d3d9dd;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  width: 100%;
  max-width: 527px;
}

.summary {
  // width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: right;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/bvn-check/Index.vue